import { Box, Icons, Text } from '@vouched.id/vault';
import React, { useEffect, useState } from 'react';
import { Dropdown } from '../../Dropdown';
import { SSNCaption } from '../SSNCaption';
import { ECBSVCompletedResult } from './ECBSVCompletedResult';
import { ECBSVRequestDataTable } from './ECBSVRequestDataTable';
import { JobType } from 'components/account/jobs/job_type';
import { useGlobalState } from 'store/reducers/reducer';
import { getSSNJob } from 'store/sagas/sagas';
export const ECBSVDropdowns = ({ jobSid, parentJobStatus }) => {
    const { asyncDispatch } = useGlobalState();
    const [eCBSVJob, setECBSVJob] = useState(null);
    useEffect(() => {
        asyncDispatch(getSSNJob(jobSid)).then((res) => {
            setECBSVJob(res[0] ?? null);
        }, console.error);
    }, [jobSid]);
    if (!eCBSVJob)
        return (React.createElement(Dropdown, { title: "SSN" },
            React.createElement(Box, null,
                React.createElement(SSNCaption, { type: JobType.ecbsvSSN }),
                React.createElement(Icons.Loading, null))));
    const [request_data] = eCBSVJob.request_data.cvsRequestList;
    const response_data = eCBSVJob.response_data?.cvsResponseData?.data.cvsResponseList[0];
    const verificationCode = response_data?.verificationCode;
    if (!verificationCode) {
        return (React.createElement(Dropdown, { title: "SSN" },
            React.createElement(Box, null,
                React.createElement(SSNCaption, { type: JobType.ecbsvSSN }),
                React.createElement(Text, null, "SSN verification could not be completed. Please try again or contact support."),
                React.createElement(Box, { display: "flex", marginTop: "spacing.default", style: { gap: '15px' } },
                    React.createElement(Text, null, "Source:"),
                    React.createElement(Text, { style: { fontWeight: '600' } }, "eCBSV")),
                request_data && React.createElement(ECBSVRequestDataTable, { requestData: request_data }))));
    }
    let deathIndicator = '';
    switch (response_data.verificationData?.deathIndicator) {
        case undefined:
            deathIndicator = 'No Result';
            break;
        case 'Y':
            deathIndicator = 'Deceased';
            break;
        case 'N':
            deathIndicator = 'Not Deceased';
    }
    return (React.createElement(ECBSVCompletedResult, { deathIndicator: deathIndicator, jobStatus: eCBSVJob.status, parentJobStatus: parentJobStatus, requestData: request_data, verified: verificationCode === 'Y' }));
};
